import React from 'react'
import { Icon, IconChoices } from '../common/Icon'
import { useAppTranslation } from '../../hooks/useAppTranslation'
import { theme } from '../../theme/theme'

export const TicketClosedBanner = ({
  className,
}: {
  className?: string
}): React.ReactNode => {
  const { translate } = useAppTranslation()

  return (
    <div className="w-full bg-neutral-98 px-4 pb-4 pt-2">
      <div
        className={`mx-auto flex w-full max-w-lg flex-col items-center rounded-2xl border border-brandGreen/40 bg-brandGreen/10 px-4 py-4 text-center ${
          className ?? ''
        }`}
      >
        <Icon
          icon={IconChoices.CHECK_CIRCLE}
          color={theme.colors.brandGreen}
          size={32}
        />
        <p style={theme.textVariants.baseBold} className="mt-2 text-black">
          {translate('ticket.closedBanner.title')}
        </p>
        <p className="mt-1 text-xs leading-5 text-black/60">
          {translate('ticket.closedBanner.subtitle')}
        </p>
      </div>
    </div>
  )
}
